import { getCookie, setCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';
import { NEXT_REDIRECT_OBJECT_HOMEPAGE } from '../../config/constants';
import { getAuthenticationStatus } from '../api/auth.api';

/**
  WithAuth will hit mp-backend authentication api if isLoggedIn 
  is false will redirect to sso with return path as current path
*/

/**
auth-failed-retry cookie is used as fail safe to prevent website from getting 
into a recursive loop
For example /checkout/prod-itr ----> will hit backend(mp-backend) and this fails 
it will send the request to sso as a return path is /checkout/prod-itr after login 
this request will again comeback to /checkout/prod-itr as mp-backend is down this will
fail again and will create a loop

To protect it from going into infinite loop we have used auth-failed-retry cookie which will
try for 3 times else will send this to home page
 */
const COOKIE_MAX_AGE = 60 * 6 * 24;
const RETRY_ATTEMPTS = 3;

// eslint-disable-next-line @typescript-eslint/ban-types
export function withAuth(cb: Function) {
  return async (ctx: GetServerSidePropsContext) => {
    const { req, res } = ctx;
    const authFailedRetries = getCookie('auth-failed-retry', ctx) as string;
    if (!authFailedRetries || parseInt(authFailedRetries) < RETRY_ATTEMPTS) {
      const auth = await getAuthenticationStatus(req.headers.cookie);
      const returnPath = Buffer.from(req.url as string).toString('base64');
      if (!auth || (auth && !auth.isLoggedIn)) {
        setCookie(
          'auth-failed-retry',
          authFailedRetries ? parseInt(authFailedRetries) + 1 : 1,
          { req, res, maxAge: COOKIE_MAX_AGE }
        );
        return {
          redirect: {
            destination: `${process.env.NEXT_PUBLIC_SSO_ENDPOINT}&return_path=${returnPath}`,
            permanent: false,
          },
        };
      } else return cb(ctx, auth);
    } else {
      setCookie('auth-failed-retry', 0, { req, res, maxAge: COOKIE_MAX_AGE });
      return NEXT_REDIRECT_OBJECT_HOMEPAGE;
    }
  };
}
